export default __webpack_public_path__ + "static/media/wo.b9050544.jpg";